// This is to override Sparklayer styles that are rendered in the shadow DOM.
const sheet = new CSSStyleSheet();
sheet.replaceSync(`.product-price-wrapper { justify-content: center !important; }`);

function styleCards() {
  document.querySelectorAll('spark-product-card').forEach(card => {
    const root = card.shadowRoot;
    if (root && !root.adoptedStyleSheets.includes(sheet)) {
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    }
  });
}

styleCards();
new MutationObserver(styleCards).observe(document.body, { childList: true, subtree: true });